export default __webpack_public_path__ + "static/media/40.3b52c38f.png";